<div class="row mt-2 mr-1">
    <div class="col-12">
        <div class="inputWithIcon inputWithIcon-search float-right d-flex">
            <app-advanced-mode id="cboGridItemAdvancedSwitch" [storageKey]="'cbo-payments-list-item'"
                (collapsibleToggle)="enableAdvanced=$event">
            </app-advanced-mode>
            <input #search kendoTextBox class="ml-4 button-search" placeholder="{{ 'SEARCH-CASE-NAME' | translate }}"
                (keyup)="searchFieldChange(search.value)" title="{{ 'SEARCH-CASE-NAME' | translate }}" />
        </div>
    </div>
</div>
<div class="mt-3 ml-3 mr-3">
    <kendo-grid #grid [data]="gridView" [navigable]="true"
        [pageable]="count > state.take ? { buttonCount: 5, pageSizes: pageSizes} : false" [pageSize]="state.take"
        [skip]="state.skip" [loading]="loading" [sort]="state.sort" [filter]="state.filter" [sortable]="true"
        [filterable]="enableAdvanced" [columnMenu]="enableAdvanced" [resizable]="true" [reorderable]="enableAdvanced"
        [kendoGridSelectBy]="'id'" [selectedKeys]="selectedRecordKeys" (columnReorder)="onReorder($event)"
        (columnResize)="onResize($event)" (columnVisibilityChange)="onVisibilityChange($event)"
        (selectedKeysChange)="onSelectedKeysChange($event)" [selectable]="{ mode: 'multiple'}"
        (dataStateChange)="dataStateChange($event);">
        <kendo-grid-messages noRecords="{{ 'NO-RECORDS' | translate }}">
        </kendo-grid-messages>
        <kendo-grid-checkbox-column *ngIf="isRevenueAnalystRole" [columnMenu]="false" [showSelectAll]="true"
            [width]="20" class="text-center" headerClass="text-center">
            <ng-template kendoGridHeaderTemplate>
                <div class="w-100">
                    <input id="selectAllCheckboxId" kendoGridSelectAllCheckbox [state]="selectAllState"
                        (selectAllChange)="onSelectAllChange($event)" type="checkbox" kendoCheckBox />
                    <label class="k-checkbox-label" for="selectAllCheckboxId"></label>
                </div>
            </ng-template>
            <ng-template kendoGridCellTemplate let-idx="rowIndex" let-dataItem>
                <input [kendoGridSelectionCheckbox]="idx" type="checkbox" kendoCheckBox />
            </ng-template>
        </kendo-grid-checkbox-column>
        <ng-template kendoGridToolbarTemplate [position]="'top'" *ngIf="enableAdvanced">
            <button kendoButton (click)="resetGridColumns()" class="float-right">
                {{'RESET-GRID-COLUMNS' | translate }}
            </button>
            <button kendoButton (click)="refresh()" class="float-right">
                {{'GRID-REFRESH' | translate }}<i class="far fa-sync-alt mt-1"></i>
            </button>
            <button *ngIf="isRevenueAnalystRole" class="float-right" kendoButton [primary]="true" type="button"
                [disabled]="selectedRecordKeys.length === 0" (click)="openChangeOrgPaymentStatusDialogOpened()">
                {{'CHANGE-ORG-PAYMENT-STATUS' | translate }}<span *ngIf="getSelectedCount() > 0"
                    class="ml-1">({{getSelectedCount()}})</span>
            </button>
            <button type="button" kendoGridExcelCommand [disabled]="count === 0">
                {{'EXPORT-TO-EXCEL' | translate }}<i class="fal fa-file-excel" style="width: 15px;color:white"></i>
            </button>
        </ng-template>
        <kendo-grid-column *ngFor="let col of view.columnsConfig" [field]="col.field" [title]="col.title"
            [width]="col.width" [filter]="col.filter" [editor]="col.editor" [format]="col.format"
            [filterable]="col.filterable !== undefined ? col.filterable : true"
            [hidden]="col.hidden !== undefined ? col.hidden : false" [editable]="col.field === 'id' ? false : true"
            [class]="col.filter === 'boolean' ? 'text-center' : (col.class ? col.class : '')">
            <!--status-->
            <ng-template kendoGridFilterCellTemplate let-filter *ngIf="col.field === 'caseBillableStatus'">
                <app-dropdown-filter [filter]="filter" [data]="invoiceItemStatuses" filterField="caseBillableStatus"
                    selectDefaultText="{{ 'SELECT-STATUS' | translate }}" textField="label" valueField="ordinalValue">
                </app-dropdown-filter>
            </ng-template>
            <ng-template kendoGridCellTemplate let-dataItem *ngIf="col.field === 'caseBillableStatus'">
                {{dataItem.caseBillableStatusText }}
            </ng-template>
            <ng-template kendoGridFilterCellTemplate let-filter let-column="column" *ngIf="col.filter === 'numeric'">
                <kendo-grid-numeric-filter-cell [column]="column" [filter]="filter" [spinners]="false">
                </kendo-grid-numeric-filter-cell>
            </ng-template>
        </kendo-grid-column>
        <kendo-grid-excel fileName="ORGPaymentItems.xlsx" [fetchData]="allData"></kendo-grid-excel>
    </kendo-grid>
</div>

<!-- Change Org Payment Status dialog -->
<kendo-dialog *ngIf="changeOrgPaymentStatusDialogOpened" title="{{'PLEASE-CONFIRM' | translate}}" [width]="510"
    (close)="cancelChangeOrgPaymentStatus()">
    <form [formGroup]="updateOrgPaymentForm">
        <p>{{'CONFIRM-CHANGE-ORG-PAYMENT-STATUS' | translate}}</p>
        <div class="row">
            <div class="col-7 pt-2 pr-0">
                <span class="k-text-uppercase dark w-100">{{'NEW-ORG-PAYMENT-STATUS' | translate}} *</span>
            </div>
            <div class="col-5">
                <kendo-combobox [filterable]="false" class="w-100" [data]="orgPaymentStatuses"
                    [textField]="'displayName'" [valueField]="'id'" formControlName="newOrgPaymentStatus"
                    [valuePrimitive]="true">
                </kendo-combobox>
            </div>
        </div>
    </form>
    <kendo-dialog-actions>
        <button kendoButton type="button" (click)="cancelChangeOrgPaymentStatus()">{{ 'CANCEL' | translate }}</button>
        <button appPreventClick kendoButton type="button" (click)="changeOrgPaymentStatus()"
            [disabled]="updateOrgPaymentForm.invalid">
            {{'SAVE' | translate}}
        </button>
    </kendo-dialog-actions>
</kendo-dialog>